import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { VibeOverview } from "redmond";
import { SanitizedHtml } from "halifax";
import styles from "./styles.module.scss";

export interface HeroSectionProps {
  isMobile: boolean;
  vibeOverview: VibeOverview;
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  isMobile,
  vibeOverview,
}) => {
  const heroMedia = vibeOverview.media?.[0];
  const backgroundStyle = heroMedia?.source
    ? { backgroundImage: `url(${heroMedia.source})` }
    : undefined;

  return (
    <Box className={clsx(styles.root, { [styles.mobile]: isMobile })}>
      <Box className={styles.imageArea} style={backgroundStyle}>
        <Box className={styles.shape}>
          <Typography className={styles.collection} variant="overline">
            Premium stays
          </Typography>
          <Typography
            className={styles.title}
            variant="h2"
            component="div"
          >
            <SanitizedHtml html={vibeOverview.title} />
          </Typography>
        </Box>
      </Box>
      <Box className={styles.overview}>
        <Typography className={styles.eyebrow} variant="overline">
          {vibeOverview.overviewHeader}
        </Typography>

        <Typography
          className={styles.description}
          variant="h3"
          component="div"
        >
          <SanitizedHtml html={vibeOverview.description ?? ""} />
        </Typography>
      </Box>
    </Box>
  );
};
